import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../../configs/api";
import { Link } from "react-router-dom";
import { getProxyUrl } from "../../utils/proxy";

const TopMoviesSidebar = () => {
  const [movies, setMovies] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/phim_rank/xemnhieunhat`)
      .then((response) => {
        const data = response.data.slice(0, 5);
        setMovies(data);
      })
      .catch((error) => console.error("Error fetching movie data:", error));
  }, []);

  return (
    <div className="hidden md:block mt-8 pt-6 border-t border-gray-700/50">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-8 h-8 bg-orange-500/20 rounded-lg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            className="text-orange-400"
          >
            <path
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M3.518 10.306c-.388-1.074-.582-1.611-.5-1.955c.091-.377.359-.67.701-.768c.313-.09.8.127 1.773.56c.86.382 1.29.573 1.695.563c.446-.012.874-.19 1.215-.507c.31-.287.517-.744.932-1.658l.915-2.016C11.013 2.842 11.395 2 12 2s.987.842 1.751 2.525l.915 2.016c.415.914.623 1.371.932 1.658c.341.316.77.495 1.215.507c.404.01.835-.181 1.695-.564c.974-.432 1.46-.649 1.773-.559c.342.098.61.391.7.768c.083.344-.111.88-.5 1.955l-1.667 4.616c-.714 1.975-1.07 2.962-1.817 3.52S15.285 19 13.356 19h-2.712c-1.93 0-2.894 0-3.64-.558c-.747-.558-1.104-1.545-1.818-3.52zM12 14h.009M7 22h10"
              color="currentColor"
            />
          </svg>
        </div>
        <h3 className="text-lg font-bold text-white">Top Phim Tuần Này</h3>
      </div>

      {/* Movies List */}
      <div className="space-y-4">
        {movies.map((movie, index) => (
          <div
            key={movie.id}
            className="flex items-start gap-4 transition-colors duration-200 group"
          >
            {/* Rank Number */}
            <div className="text-orange-400 text-[3rem] lg:text-[3rem] 2xl:text-[3rem] italic font-bold font-seogoe">
              {index + 1}
            </div>

            {/* Movie Poster */}
            <div className="flex-shrink-0">
              <img
                src={movie.poster_url || getProxyUrl(movie.poster)}
                alt={movie.ten_phim}
                className="w-16 h-24 object-cover rounded-md "
                onError={(e) =>
                  (e.target.src = "https://via.placeholder.com/64x96?text=Err")
                }
              />
            </div>

            {/* Movie Info */}
            <div className="flex-1 min-w-0 space-y-3">
              <Link
                to={`/phim/${movie.slug}`}
                className="block text-sm font-semibold text-white hover:text-orange-400 transition-colors duration-200 line-clamp-2 leading-tight"
              >
                {movie.ten_phim}
              </Link>

              {movie.ten_khac && (
                <p className="text-xs text-gray-400 line-clamp-1">
                  {movie.ten_khac}
                </p>
              )}

              <div className="flex flex-wrap gap-2 text-xs text-gray-300">
                {movie.tinh_trang && <span>{movie.tinh_trang}</span>}
                {movie.ngon_ngu && movie.tinh_trang && <span>•</span>}
                {movie.ngon_ngu && <span>{movie.ngon_ngu}</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopMoviesSidebar;
